import type { CalendarProviderIntegration } from "@kontextwerk/control-web-client"
import { selectedReadCalendarIds, selectedWriteCalendarId } from "../calendar-configuration"
import { setupSteps, type CalendarSetupStep } from "../contract"

export const completedSetupSteps = (
  integration: CalendarProviderIntegration | null,
): CalendarSetupStep[] => {
  if (!integration?.calendar_capability_active || integration.account_status !== "connected")
    return []

  const completed: CalendarSetupStep[] = ["connect_account"]
  const writeId = selectedWriteCalendarId(integration.calendars)

  if (!writeId) return completed

  completed.push("select_write_target")
  const readIds = selectedReadCalendarIds(integration.calendars)
  const write = integration.calendars.find((calendar) => calendar.provider_calendar_id === writeId)

  if (readIds.length && (!write?.can_import_events || readIds.includes(writeId)))
    completed.push("select_read_sources")

  return completed
}

export const resolveSetupStep = (
  integration: CalendarProviderIntegration | null,
  requested?: CalendarSetupStep | null,
): CalendarSetupStep => {
  const completed = completedSetupSteps(integration)
  const firstIncomplete = completed.length

  if (requested && setupSteps.indexOf(requested) <= firstIncomplete) return requested

  return setupSteps[firstIncomplete] ?? "summary"
}

export const parseSetupStep = (search: string): CalendarSetupStep | null => {
  const value = new URLSearchParams(search).get("calendar_setup_step")

  return setupSteps.find((step) => step === value) ?? null
}

export const sameCalendarIds = (left: string[], right: string[]): boolean =>
  new Set(left).size === new Set(right).size && left.every((id) => right.includes(id))
